var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.collection),function(m){return _c('div',{staticClass:"col-lg-2 mt-2"},[_c('div',{staticClass:"card card-body bg-light"},[_c('a',{attrs:{"href":'#/users/' + m._id}},[_vm._v(_vm._s(m.name))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8df3998e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/user_list/components/list.vue
// module id = Ysko
// module chunks = 1